export default "__VITE_ASSET__abe606a5__"